import { getOrderHighlightFieldValues } from '../../utils/orderHighlightDetailsUtils';
import ContactEmail from '../HighlightCard/HighlightDetails/ContactEmail';
import CreatedDate from '../HighlightCard/HighlightDetails/CreatedDate';
import Field from '../HighlightCard/HighlightDetails/atomic/Field';
import Phone from '../HighlightCard/HighlightDetails/Phone';
import Pipeline from '../HighlightCard/HighlightDetails/Pipeline';
import Stage from '../HighlightCard/HighlightDetails/Stage';
import { ORDER_HIGHLIGHT_DETAILS } from '../../constants/dataTestIds';
import BilledCustomerName from '../HighlightCard/HighlightDetails/BilledCustomerName';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OrderHighlightDetails = ({
  properties,
  pipelines
}) => {
  const {
    createdDate,
    email,
    phone,
    pipeline,
    stage,
    billedCustomerName
  } = getOrderHighlightFieldValues({
    properties,
    pipelines
  });
  return /*#__PURE__*/_jsxs(View, {
    textAlign: "left",
    marginBlock: "400",
    "data-test-id": ORDER_HIGHLIGHT_DETAILS,
    children: [/*#__PURE__*/_jsx(CreatedDate, {
      value: createdDate
    }), /*#__PURE__*/_jsx(Stage, {
      value: stage
    }), /*#__PURE__*/_jsx(Pipeline, {
      value: pipeline
    }), /*#__PURE__*/_jsx(Phone, {
      value: phone
    }), /*#__PURE__*/_jsx(ContactEmail, {
      value: email
    }), /*#__PURE__*/_jsx(BilledCustomerName, {
      value: billedCustomerName
    }), /*#__PURE__*/_jsx(Field, {})]
  });
};
export default OrderHighlightDetails;